import { render, staticRenderFns } from "./chooseVIP.vue?vue&type=template&id=0e679cf2&scoped=true&"
import script from "./chooseVIP.vue?vue&type=script&lang=js&"
export * from "./chooseVIP.vue?vue&type=script&lang=js&"
import style0 from "./chooseVIP.vue?vue&type=style&index=0&id=0e679cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e679cf2",
  null
  
)

export default component.exports